import { CLOSE_ALL_OVERLAYS, OPEN_COUNTRIES_MENU } from "layout/redux/overlay.actions";
import OverlayRootState from "layout/models/redux-state.interface";
import { PAGE_TYPE } from "app/umbraco/pages/page.types";

export default (event: any, currentPage: PAGE_TYPE, dispatch: any, overlay?: OverlayRootState) => {
    if (event) {
        event.stopPropagation();
    }

    if (overlay?.currentOverlay === "COUNTRIES_MENU") {
        dispatch({
            type: CLOSE_ALL_OVERLAYS,
        });
    } else {
        dispatch({
            type: OPEN_COUNTRIES_MENU,
        });
    }
};
